export enum PuzzleGameEnum {
  Sudoku = 'Sudoku',
  Lemonade = 'Lemonade',
  Sliding = 'Puzzle_Master',
  Tower = 'Brain_Defense',
  Trail = 'Synapse_Scramble',
  LargeSudoku = 'Large_Sudoku',
  GuessWho = 'The_Fame_Game',
  Bridge = 'Bridge'
}
